const TRANSACTION_KEY = "transaction_id";
import { getDevice } from "../devices";

export const getTransactionDetails = async (transactionId: string) => {
  const response = await fetch(`/api/v1/transaction/${transactionId}`);
  const transaction = await response.json();

  return transaction;
};

export const finalizeTransaction = async (
  deviceId: string,
  transactionId: string,
  squareId: string | undefined
) => {
  if (!deviceId) {
    throw new Error(`Device ID is required.`);
  }

  if (!transactionId) {
    throw new Error(`Transaction ID is required.`);
  }

  const device = await getDevice(deviceId);

  if (!device) {
    throw new Error(`Device ${deviceId} could not be found.`);
  }

  await fetch(`/api/v1/transaction/callback/${transactionId}`, {
    method: "post",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      locationId: device.squareupSettings.locationId,
      personalAccessToken: device.squareupSettings.personalAccessToken,
      squareId
    })
  });
};

export const getCurrentTransactionId = (): string | null =>
  localStorage.getItem(TRANSACTION_KEY);

export const setCurrentTransaction = (transactionId?: string) =>
  transactionId
    ? localStorage.setItem(TRANSACTION_KEY, transactionId)
    : localStorage.removeItem(TRANSACTION_KEY);

export const clearCurrentTransaction = () => setCurrentTransaction();



// WEBPACK FOOTER //
// ./src/services/transactions/index.ts